import { Box, CardMedia, Typography, useMediaQuery, useTheme } from "@mui/material"
import { animated, useSpring } from "react-spring"
import { SliderItemProps } from "./types"
import { useMemo } from "react";
import { sliderItemSizes } from "../../mockData";
import { sliderItemStyles } from "./mockData";

const SliderItem = ({
  icon,
  label,
  options
}: SliderItemProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery("(max-width: 681px)");
  const isLargeDesktop = useMediaQuery("(max-width: 1679px)");

  const [animatedStyles] = useSpring(() => options, []);
  const width = useMemo(() => {
    if (isMobile) {
      return sliderItemSizes.xs.width;
    };
    if (isLargeDesktop) {
      return sliderItemSizes.lg.width;
    };
    return sliderItemSizes.xl.width;
  }, [isMobile, isLargeDesktop]);

  const styles = useMemo(() => {
    if (isMobile) {
      return sliderItemStyles.xs;
    };
    if (isLargeDesktop) {
      return sliderItemStyles.lg;
    };
    return sliderItemStyles.xl;
  }, [isMobile, isLargeDesktop]);

  const Animated = animated((props) => (
    <Box
      {...props}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.common.white,
        width: width,
        boxSizing: "border-box",
        borderRadius: "3px",
        ...styles.container
      }}
    >
      <CardMedia 
        component="img"
        image={icon}
        sx={styles.icon}
      />
      <Typography sx={{ 
          textWrap: "nowrap",
          ...styles.label
        }}
      >
        {label}
      </Typography>
    </Box>
  ));
  return (
    <Animated style={animatedStyles} />
  );
};

export default SliderItem;
